// relatorios-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "\"Confirmadas pelo app\" não é taxa de entrega: no Android, quando o app está fechado, o aparelho exibe a notificação sozinho e o app nunca fica sabendo — por isso esse número fica baixo mesmo quando a entrega foi normal. \"Lida\" e \"clicada\" também só contam quando o aplicativo confirma ao servidor. Já \"Aberturas influenciadas\" pega quem recebeu a push, não tocou nela, mas abriu o app pelo ícone em até 24h — é sinal real de resultado do envio.": "\"Confirmadas por la app\" no es tasa de entrega: en Android, cuando la app está cerrada, el dispositivo muestra la notificación por sí solo y la app nunca se entera — por eso ese número queda bajo aunque la entrega haya sido normal. \"Leída\" y \"clicada\" también solo cuentan cuando la aplicación confirma al servidor. En cambio, \"Aperturas influenciadas\" toma a quien recibió la push, no la tocó, pero abrió la app desde el ícono en hasta 24h — es señal real de resultado del envío.",
    "% configurado": "% configurado",
    "% real": "% real",
    "0 l": "0 l",
    "Agrupar por:": "Agrupar por:",
    "Campanha automática dispara uma vez por cliente que bateu a regra; envio único e recorrente são decisão manual.": "La campaña automática se dispara una vez por cliente que cumplió la regla; el envío único y el recurrente son decisión manual.",
    "Carência (meses)": "Carencia (meses)",
    "Cinco ou mais vezes": "Cinco o más veces",
    "Cliente que Indicou": "Cliente que Refirió",
    "Clientes Cadastrados": "Clientes Registrados",
    "Clientes Indicadores": "Clientes Referidores",
    "Clientes Recorrentes": "Clientes Recurrentes",
    "Clientes e Reabastecimentos": "Clientes y Recargas de Combustible",
    "Clientes que Abasteceram": "Clientes que Cargaron Combustible",
    "Clique": "Clic",
    "Concluído em": "Concluido en",
    "Concluídos": "Concluidos",
    "Confirmação": "Confirmación",
    "Cupons estornados": "Cupones revertidos",
    "Código do Cupon": "Código del Cupón",
    "Data de Cadastro": "Fecha de Registro",
    "Data de nascimento": "Fecha de nacimiento",
    "Data do Estorno": "Fecha de la Reversión",
    "Descontos Cadastrados": "Descuentos Registrados",
    "Detalhamento": "Detalle",
    "Disparos": "Disparos",
    "Duas vezes": "Dos veces",
    "Endereço Completo": "Dirección Completa",
    "Enquete": "Encuesta",
    "Entrega": "Entrega",
    "Envios do dia": "Envíos del día",
    "Erro ao buscar relatório de preço real": "Error al buscar el reporte de precio real",
    "Erro ao carregar Relatório de Avaliações do Posto": "Error al cargar el Reporte de Evaluaciones de la Estación",
    "Erro ao carregar locais de compra.": "Error al cargar los lugares de compra.",
    "Erro ao carregar produtos em estoque": "Error al cargar productos en stock",
    "Erro ao carregar produtos vendidos": "Error al cargar productos vendidos",
    "Erro ao carregar redes de postos.": "Error al cargar las redes de estaciones.",
    "Erros do Socket": "Errores del Socket",
    "Estoque restante": "Stock restante",
    "Estorno realizado por": "Reversión realizada por",
    "Extrato de Cupons Resgatados": "Extracto de Cupones Canjeados",
    "Falharam": "Fallaron",
    "Fatia": "Sector",
    "Fillin ID": "Fillin ID",
    "Forma Pagamento": "Forma de Pago",
    "Ganhou o giro": "Ganó el giro",
    "Gestão Click ID": "Gestão Click ID",
    "Início Faturamento": "Inicio Facturación",
    "Linha do tempo": "Línea de tiempo",
    "Lista de Clientes (": "Lista de Clientes (",
    "Local de Troca": "Lugar de Canje",
    "Local de compra": "Lugar de compra",
    "Marca Concentrador": "Marca del Concentrador",
    "Marca da Automação": "Marca de la Automatización",
    "Mensagens enviadas": "Mensajes enviados",
    "Min. Abastecimentos": "Mín. Cargas de Combustible",
    "Movimentação de estoque - Resumo": "Movimiento de stock - Resumen",
    "Média de nota do posto": "Promedio de calificación de la estación",
    "Média de nota dos frentistas": "Promedio de calificación de los playeros",
    "Mês:": "Mes:",
    "Nenhum dado encontrado para os filtros selecionados.": "No se encontraron datos para los filtros seleccionados.",
    "Nenhum envio no período.": "Ningún envío en el período.",
    "Nenhum posto encontrado sem boleto para o período selecionado.": "No se encontró ninguna estación sin boleto para el período seleccionado.",
    "Nenhuma mensagem enviada no período.": "Ningún mensaje enviado en el período.",
    "Nenhuma notificação enviada no período selecionado.": "Ninguna notificación enviada en el período seleccionado.",
    "Nº da Rua": "Nº de la Calle",
    "Não configurado": "No configurado",
    "Não mapeado": "No mapeado",
    "Número de Indicações": "Número de Referidos",
    "Pagamento Inválido": "Pago Inválido",
    "Peso": "Peso",
    "Pontos Estimados": "Puntos Estimados",
    "Pontos de troca": "Puntos de canje",
    "Por fatia": "Por sector",
    "Por tipo de envio": "Por tipo de envío",
    "Porcentagem da revenda": "Porcentaje del revendedor",
    "Produtos Resgatados": "Productos Canjeados",
    "Produtos Vendidos": "Productos Vendidos",
    "Produtos resgatados": "Productos canjeados",
    "Próximo Retry": "Próximo reintento",
    "Qtd Postos": "Cant. Estaciones",
    "Quando cada envio saiu e como a leitura reagiu": "Cuándo salió cada envío y cómo reaccionó la lectura",
    "Quantidade de Cupons": "Cantidad de Cupones",
    "Quantidade de Litros": "Cantidad de Litros",
    "Quantidade de Postos": "Cantidad de Estaciones",
    "Quantidade de usos": "Cantidad de usos",
    "Quatro vezes": "Cuatro veces",
    "Reabastecimentos": "Recargas de combustible",
    "Regra de Pontuação": "Regla de Puntuación",
    "Relatório de Avaliação de Postos": "Reporte de Evaluación de Estaciones",
    "Relatório de Pontuação": "Reporte de Puntuación",
    "Relatório de Preço Real": "Reporte de Precio Real",
    "Relatório de Produtos Vendidos": "Reporte de Productos Vendidos",
    "Relatório de Revendas": "Reporte de Revendedores",
    "Relatório de Valores CTT": "Reporte de Valores CTT",
    "Relatório de movimentação de estoque - Resumo": "Reporte de movimiento de stock - Resumen",
    "Responsável": "Responsable",
    "Revenda não identificada": "Revendedor no identificado",
    "Selecione uma regra de pontuação para visualizar o relatório.": "Seleccione una regla de puntuación para visualizar el reporte.",
    "Selecione uma roleta para visualizar o relatório.": "Seleccione una ruleta para visualizar el reporte.",
    "Soma dos pontos negativos": "Suma de los puntos negativos",
    "Soma dos pontos positivos": "Suma de los puntos positivos",
    "Status da rede": "Estado de la red",
    "Status do posto": "Estado de la estación",
    "TOTAL": "TOTAL",
    "Tentativas": "Intentos",
    "Tipo da fatia": "Tipo de sector",
    "Tipo de Desconto": "Tipo de Descuento",
    "Tipo de Enquete": "Tipo de Encuesta",
    "Tipo do desconto": "Tipo de descuento",
    "Tipos de envio": "Tipos de envío",
    "Totais por Combustível": "Totales por Combustible",
    "Total Faturamento": "Total Facturación",
    "Total Valor CTT": "Total Valor CTT",
    "Total de Abastecimentos": "Total de Cargas de Combustible",
    "Total de Ocorrências": "Total de Ocurrencias",
    "Total em Pontos": "Total en Puntos",
    "Total em R$": "Total en R$",
    "Três vezes": "Tres veces",
    "Uma vez": "Una vez",
    "Validações de Pagamento Quality": "Validaciones de Pago Quality",
    "Valor CTT": "Valor CTT",
    "Valor Faturamento": "Valor Facturación",
    "Valor R$": "Valor R$",
    "Valor da Instalação": "Valor de la Instalación",
    "Valor do Faturamento": "Valor de la Facturación",
    "Valor em Reais": "Valor en Reales",
    "Versão crtl": "Versión crtl",
    "Vezes sorteada": "Veces sorteada",
    "abriu a tela indicada": "abrió la pantalla indicada",
    "app avisou que recebeu": "la app avisó que la recibió",
    "de leitura": "de lectura",
    "enviadas ·": "enviadas ·",
    "mensagens no período": "mensajes en el período",
    "tocou na notificação": "tocó la notificación",
    "· média Android/iOS, calculada sobre enviadas.": "· promedio Android/iOS, calculado sobre enviadas.",
};

export default catalogo;
